// src/encounter/vaccination-admin-dialog.tsx
// Modal host for the VaccinationAdminEditor (PROD-1227 composition seam). The editor is a
// self-contained card (own header + form + footer); this wraps it in the DS Modal for focus-trap +
// backdrop + Esc (CLAUDE.md: use the DS Modal, don't hand-roll a modal stack). Keyed-remount on the
// editor's identity re-initialises the RHF form from `initial` each open (mirrors VitalsEditDialog).
//
// Used by BOTH seams: the nurse pre-encounter "Give"/"Edit" (encounter-shell-page) and — once it
// lands — the doctor A&P "+ Vaccine" add. Presentational: the host supplies vaccine/initial/save.
import { Modal } from '@scripsteam/scrips-signal-ds';
import { VaccinationAdminEditor, type VaccinationDraft } from './vaccination-admin-editor';
import type { VaccineValueSet } from '@/shared/services/use-vaccination-search';

export interface VaccinationAdminDialogProps {
  open: boolean;
  /** Re-initialise the form when this changes (the request/order id) — keyed remount. */
  editorKey?: string;
  vaccine: VaccineValueSet;
  /** true = nurse administering (lot/expiry/etc. mandatory); false = doctor editing the request. */
  isAdministration: boolean;
  initial?: Partial<VaccinationDraft>;
  saving?: boolean;
  saveLabel?: string;
  /** Form-level save failure, surfaced by the editor above its actions. */
  saveError?: string;
  onSave: (draft: VaccinationDraft) => void;
  onClose: () => void;
}

export function VaccinationAdminDialog({ open, editorKey, onClose, ...editor }: VaccinationAdminDialogProps) {
  if (!open) return null;
  return (
    <Modal open onClose={onClose} size="lg">
      <VaccinationAdminEditor key={editorKey} {...editor} onCancel={onClose} />
    </Modal>
  );
}
